import {Stack} from '@mui/material'
import React from 'react'
import Label from '../../customTable/Label'

export default function SeoLabelWithIcon({item}: any) {
  return (
    <Stack gap='5px' alignItems={'center'} direction={'row'}>
      {item.icon} <Label fw='400' fs='14px' color='#5E6278' text={item.text} />
      {item.value && ':'} {item.value}
    </Stack>
  )
}
